const menuList = [
    {
        title: '使用量统计',
        key: '/gpt-admin',
        icon: 'radar-chart'
    },
];

export default menuList;